const _excluded = ["data"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { v4 as uuidv4 } from 'uuid';
export const mapMessage = message => _objectSpread(_objectSpread({}, message), {}, {
  id: message._id,
  date: message.createdAt,
  from: message.from._id
});

const createAlbum = filesList => filesList.map(file => ({
  content: file.url,
  type: file.type
}));

const messageContentConstructor = _ref => {
  let type = _ref.type,
      content = _ref.content;

  switch (type) {
    case 'album':
      return createAlbum(content);

    case 'text':
    case 'file':
      return content;

    case 'audio':
    case 'image':
    case 'video':
      return content.url;
  }
};

export const messageConstructor = _ref2 => {
  let data = _ref2.data,
      message = _objectWithoutProperties(_ref2, _excluded);

  return _objectSpread(_objectSpread({
    temporalId: uuidv4()
  }, message), {}, {
    type: data.type,
    content: messageContentConstructor(data),
    caption: data.caption,
    date: Date(),
    status: 'pending'
  });
};
export const getGroupMessagesExample = () => [{
  id: 'msj1gg',
  from: {
    id: 'usr1',
    name: 'Fabio',
    image: 'https://i2.wp.com/xn--oo-yjab.cl/wp-content/uploads/2016/12/goomba-mario-bros-nintendo.jpg?fit=249%2C249&ssl=1'
  },
  type: 'text',
  content: 'Hola que tal',
  replyTo: null,
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'seen'
}, {
  id: 'msj2g',
  from: {
    id: 'usr1',
    name: 'Fabio',
    image: 'https://i2.wp.com/xn--oo-yjab.cl/wp-content/uploads/2016/12/goomba-mario-bros-nintendo.jpg?fit=249%2C249&ssl=1'
  },
  type: 'image',
  content: 'https://cdn02.nintendo-europe.com/media/images/10_share_images/games_15/nintendo_ds_22/SI_NDS_NewSuperMarioBrosDS_image1600w.jpg',
  replyTo: 'msj1ggg',
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'seen'
}, {
  id: 'msj3g.1',
  from: {
    id: 'usr2',
    name: 'Miguel',
    image: 'https://static.wikia.nocookie.net/mario/images/4/4d/Yoshi_-_Mario_Party_10.png/revision/latest/smart/width/250/height/250?cb=20171012174642&path-prefix=es'
  },
  type: 'audio',
  content: 'http://d2cstorage-a.akamaihd.net/wbr/gotnext/8578.mp3',
  replyTo: 'msj1g',
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'seen'
}, {
  id: 'msj3g',
  from: {
    id: 'usr2',
    name: 'Miguel',
    image: 'https://static.wikia.nocookie.net/mario/images/4/4d/Yoshi_-_Mario_Party_10.png/revision/latest/smart/width/250/height/250?cb=20171012174642&path-prefix=es'
  },
  type: 'text',
  content: 'Como estan todos?',
  replyTo: 'msj3g.1',
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'seen'
}, {
  id: 'msj4g',
  from: {
    id: 'usr3',
    name: 'Juvencio',
    image: 'https://imagenes.20minutos.es/files/image_656_370/files/fp/uploads/imagenes/2020/08/25/mario-bros.r_d.172-8-23345.jpeg'
  },
  type: 'text',
  content: 'Todo bien por aca',
  replyTo: null,
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'seen'
}, {
  id: 'msj5g',
  from: {
    id: 'usr1',
    name: 'Fabio',
    image: 'https://i2.wp.com/xn--oo-yjab.cl/wp-content/uploads/2016/12/goomba-mario-bros-nintendo.jpg?fit=249%2C249&ssl=1'
  },
  type: 'text',
  content: 'Bien bien bien',
  replyTo: null,
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'seen'
}, {
  id: 'msj6g',
  from: {
    id: 'usr1',
    name: 'Fabio',
    image: 'https://i2.wp.com/xn--oo-yjab.cl/wp-content/uploads/2016/12/goomba-mario-bros-nintendo.jpg?fit=249%2C249&ssl=1'
  },
  type: 'text',
  content: 'Que han hecho?',
  replyTo: null,
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'seen'
}, {
  id: 'msj6g.1',
  from: {
    id: 'usr1',
    name: 'Fabio',
    image: 'https://i2.wp.com/xn--oo-yjab.cl/wp-content/uploads/2016/12/goomba-mario-bros-nintendo.jpg?fit=249%2C249&ssl=1'
  },
  type: 'video',
  content: 'https://www.w3schools.com/html/mov_bbb.mp4',
  replyTo: 'msj1g',
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'seen'
}, {
  id: 'msj7g',
  from: {
    id: 'usr2',
    name: 'Miguel',
    image: 'https://static.wikia.nocookie.net/mario/images/4/4d/Yoshi_-_Mario_Party_10.png/revision/latest/smart/width/250/height/250?cb=20171012174642&path-prefix=es'
  },
  type: 'image',
  content: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwmDbsPw5chP6R88yLuCNXsxwlCc1rMXhOng&usqp=CAU',
  replyTo: 'msj6g.1',
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'seen'
}, {
  id: 'msj8g',
  from: {
    id: 'usr1',
    name: 'Fabio',
    image: 'https://i2.wp.com/xn--oo-yjab.cl/wp-content/uploads/2016/12/goomba-mario-bros-nintendo.jpg?fit=249%2C249&ssl=1'
  },
  type: 'text',
  content: 'jajajajjajjajaja que tiempos',
  replyTo: 'msj7g',
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'seen'
}, {
  id: 'msj9g',
  from: {
    id: 'usr3',
    name: 'Juvencio',
    image: 'https://imagenes.20minutos.es/files/image_656_370/files/fp/uploads/imagenes/2020/08/25/mario-bros.r_d.172-8-23345.jpeg'
  },
  type: 'text',
  content: 'Varias cosassss...',
  replyTo: null,
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'seen'
}, {
  id: 'msj10g',
  from: {
    id: 'usr3',
    name: 'Juvencio',
    image: 'https://imagenes.20minutos.es/files/image_656_370/files/fp/uploads/imagenes/2020/08/25/mario-bros.r_d.172-8-23345.jpeg'
  },
  type: 'image',
  content: 'https://i.picsum.photos/id/869/75/75.jpg?hmac=D8u9WyFURoz9_hya6Kexo_uNvNWedy29nzkrCzSZ1E8' || 'https://i.pinimg.com/236x/7b/a9/56/7ba956ee47278a05c865554034bc0b51--super-mario-iphone-wallpaper.jpg',
  replyTo: null,
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'seen'
}, {
  id: 'msj11g',
  from: {
    id: 'usr3',
    name: 'Juvencio',
    image: 'https://imagenes.20minutos.es/files/image_656_370/files/fp/uploads/imagenes/2020/08/25/mario-bros.r_d.172-8-23345.jpeg'
  },
  type: 'file',
  content: {
    url: 'https://rooms-users.s3.amazonaws.com/7852d940-6210-468e-8539-ecaa9123c9ab-example_user_layout.csv',
    name: 'UserLayout',
    extension: 'csv'
  },
  replyTo: 'msj1g',
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'seen'
}, {
  id: 'msj12g',
  from: {
    id: 'usr1',
    name: 'Fabio',
    image: 'https://i2.wp.com/xn--oo-yjab.cl/wp-content/uploads/2016/12/goomba-mario-bros-nintendo.jpg?fit=249%2C249&ssl=1'
  },
  type: 'text',
  content: 'Como van con el trabajo?',
  replyTo: 'msj7g',
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'delivered'
}, {
  id: 'msj13g',
  from: {
    id: 'usr1',
    name: 'Fabio',
    image: 'https://i2.wp.com/xn--oo-yjab.cl/wp-content/uploads/2016/12/goomba-mario-bros-nintendo.jpg?fit=249%2C249&ssl=1'
  },
  type: 'text',
  content: ':v',
  replyTo: 'msj11g',
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'sending'
}, {
  id: 'msj14g',
  from: {
    id: 'usr3',
    name: 'Juvencio',
    image: 'https://imagenes.20minutos.es/files/image_656_370/files/fp/uploads/imagenes/2020/08/25/mario-bros.r_d.172-8-23345.jpeg'
  },
  type: 'album',
  content: [{
    content: 'https://img.buzzfeed.com/buzzfeed-static/static/2018-04/13/12/asset/buzzfeed-prod-web-03/sub-buzz-8755-1523636113-1.jpg?output-quality=auto&output-format=auto&downsize=640:*',
    type: 'image'
  }, {
    content: 'https://www.w3schools.com/html/mov_bbb.mp4',
    type: 'video'
  }, {
    content: 'data:image/jpeg;base64,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',
    type: 'image'
  }, {
    content: 'https://www.allcitycanvas.com/wp-content/uploads/2019/03/Last-Súper-Mario-Bros-HORIZONTAL-1280x720.jpg',
    type: 'image'
  }, {
    content: 'https://i.blogs.es/733bd1/2560_3000/840_560.jpeg',
    type: 'image'
  }, {
    content: 'https://i.blogs.es/2ed8d3/super-mario-bros-2/840_560.jpeg',
    type: 'image'
  }],
  replyTo: 'msj7g',
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'sending'
}];
export const getPrivateMessagesExample = () => [{
  id: 'msj0',
  from: {
    id: 'usr2',
    name: 'Miguel',
    image: 'https://static.wikia.nocookie.net/mario/images/4/4d/Yoshi_-_Mario_Party_10.png/revision/latest/smart/width/250/height/250?cb=20171012174642&path-prefix=es'
  },
  type: 'text',
  content: 'Hola que tal',
  replyTo: null,
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'seen'
}, {
  id: 'msj1',
  from: {
    id: 'usr1',
    name: 'Fabio',
    image: 'https://i2.wp.com/xn--oo-yjab.cl/wp-content/uploads/2016/12/goomba-mario-bros-nintendo.jpg?fit=249%2C249&ssl=1'
  },
  type: 'text',
  content: 'Hola que tal',
  replyTo: null,
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'seen'
}, {
  id: 'msj2',
  from: {
    id: 'usr1',
    name: 'Fabio',
    image: 'https://i2.wp.com/xn--oo-yjab.cl/wp-content/uploads/2016/12/goomba-mario-bros-nintendo.jpg?fit=249%2C249&ssl=1'
  },
  type: 'image',
  content: 'https://cdn02.nintendo-europe.com/media/images/10_share_images/games_15/nintendo_ds_22/SI_NDS_NewSuperMarioBrosDS_image1600w.jpg',
  replyTo: 'msj1',
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'seen'
}, {
  id: 'msj3.1',
  from: {
    id: 'usr2',
    name: 'Miguel',
    image: 'https://static.wikia.nocookie.net/mario/images/4/4d/Yoshi_-_Mario_Party_10.png/revision/latest/smart/width/250/height/250?cb=20171012174642&path-prefix=es'
  },
  type: 'audio',
  content: 'http://d2cstorage-a.akamaihd.net/wbr/gotnext/8578.mp3',
  replyTo: null,
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'seen'
}, {
  id: 'msj3',
  from: {
    id: 'usr2',
    name: 'Miguel',
    image: 'https://static.wikia.nocookie.net/mario/images/4/4d/Yoshi_-_Mario_Party_10.png/revision/latest/smart/width/250/height/250?cb=20171012174642&path-prefix=es'
  },
  type: 'text',
  content: 'Como estan todos?',
  replyTo: null,
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'seen'
}];
export const getMoreMessages = () => [{
  id: uuidv4(),
  from: {
    id: 'usr1',
    name: 'Fabio',
    image: 'https://i2.wp.com/xn--oo-yjab.cl/wp-content/uploads/2016/12/goomba-mario-bros-nintendo.jpg?fit=249%2C249&ssl=1'
  },
  type: 'text',
  content: 'Hola que taxxxxxxx',
  replyTo: null,
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'seen'
}, {
  id: uuidv4(),
  from: {
    id: 'usr2',
    name: 'Miguel',
    image: 'https://static.wikia.nocookie.net/mario/images/4/4d/Yoshi_-_Mario_Party_10.png/revision/latest/smart/width/250/height/250?cb=20171012174642&path-prefix=es'
  },
  type: 'audio',
  content: 'http://d2cstorage-a.akamaihd.net/wbr/gotnext/8578.mp3',
  replyTo: 'msj1g',
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'seen'
}, {
  id: uuidv4(),
  from: {
    id: 'usr2',
    name: 'Miguel',
    image: 'https://static.wikia.nocookie.net/mario/images/4/4d/Yoshi_-_Mario_Party_10.png/revision/latest/smart/width/250/height/250?cb=20171012174642&path-prefix=es'
  },
  type: 'text',
  content: 'Como estan todos?',
  replyTo: 'msj3g.1',
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'seen'
}, {
  id: uuidv4(),
  from: {
    id: 'usr3',
    name: 'Juvencio',
    image: 'https://imagenes.20minutos.es/files/image_656_370/files/fp/uploads/imagenes/2020/08/25/mario-bros.r_d.172-8-23345.jpeg'
  },
  type: 'text',
  content: 'Todo bien por aca',
  replyTo: null,
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'seen'
}, {
  id: uuidv4(),
  from: {
    id: 'usr1',
    name: 'Fabio',
    image: 'https://i2.wp.com/xn--oo-yjab.cl/wp-content/uploads/2016/12/goomba-mario-bros-nintendo.jpg?fit=249%2C249&ssl=1'
  },
  type: 'text',
  content: 'Bien bien bien',
  replyTo: null,
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'seen'
}, {
  id: uuidv4(),
  from: {
    id: 'usr1',
    name: 'Fabio',
    image: 'https://i2.wp.com/xn--oo-yjab.cl/wp-content/uploads/2016/12/goomba-mario-bros-nintendo.jpg?fit=249%2C249&ssl=1'
  },
  type: 'text',
  content: 'Que han hecho?',
  replyTo: null,
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'seen'
}, {
  id: uuidv4(),
  from: {
    id: 'usr1',
    name: 'Fabio',
    image: 'https://i2.wp.com/xn--oo-yjab.cl/wp-content/uploads/2016/12/goomba-mario-bros-nintendo.jpg?fit=249%2C249&ssl=1'
  },
  type: 'text',
  content: 'jajajajjajjajaja que tiempos',
  replyTo: 'msj7g',
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'seen'
}, {
  id: uuidv4(),
  from: {
    id: 'usr3',
    name: 'Juvencio',
    image: 'https://imagenes.20minutos.es/files/image_656_370/files/fp/uploads/imagenes/2020/08/25/mario-bros.r_d.172-8-23345.jpeg'
  },
  type: 'text',
  content: 'Varias cosassss...',
  replyTo: null,
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'seen'
}, {
  id: uuidv4(),
  from: {
    id: 'usr3',
    name: 'Juvencio',
    image: 'https://imagenes.20minutos.es/files/image_656_370/files/fp/uploads/imagenes/2020/08/25/mario-bros.r_d.172-8-23345.jpeg'
  },
  type: 'file',
  content: {
    url: 'https://rooms-users.s3.amazonaws.com/7852d940-6210-468e-8539-ecaa9123c9ab-example_user_layout.csv',
    name: 'UserLayout',
    extension: 'csv'
  },
  type: 'image',
  content: 'https://i.picsum.photos/id/869/75/75.jpg?hmac=D8u9WyFURoz9_hya6Kexo_uNvNWedy29nzkrCzSZ1E8' || 'https://i.pinimg.com/236x/7b/a9/56/7ba956ee47278a05c865554034bc0b51--super-mario-iphone-wallpaper.jpg',
  replyTo: null,
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'seen'
}, {
  id: uuidv4(),
  from: {
    id: 'usr1',
    name: 'Fabio',
    image: 'https://i2.wp.com/xn--oo-yjab.cl/wp-content/uploads/2016/12/goomba-mario-bros-nintendo.jpg?fit=249%2C249&ssl=1'
  },
  type: 'text',
  content: 'Como van con el trabajo?',
  replyTo: 'msj7g',
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'delivered'
}, {
  id: uuidv4(),
  from: {
    id: 'usr1',
    name: 'Fabio',
    image: 'https://i2.wp.com/xn--oo-yjab.cl/wp-content/uploads/2016/12/goomba-mario-bros-nintendo.jpg?fit=249%2C249&ssl=1'
  },
  type: 'text',
  content: ':v',
  replyTo: 'msj11g',
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'sending'
}, {
  id: uuidv4(),
  from: {
    id: 'usr3',
    name: 'Juvencio',
    image: 'https://i1.wp.com/hipertextual.com/wp-content/uploads/2019/12/hipertextual-mario-kart-tour-estrena-modo-multijugador-fase-beta-asi-puedes-probarlo-2019195510.jpg?fit=1800%2C1200&ssl=1'
  },
  type: 'album',
  content: [{
    content: 'https://cdn.computerhoy.com/sites/navi.axelspringer.es/public/media/image/2019/08/mario-kart.jpg',
    type: 'image'
  }, {
    content: 'https://www.w3schools.com/html/mov_bbb.mp4',
    type: 'video'
  }, {
    content: 'https://www.enter.co/wp-content/uploads/2018/02/Mario-Kart-Tour-para-moviles-768x432.jpg',
    type: 'image'
  }, {
    content: 'https://www.allcitycanvas.com/wp-content/uploads/2019/03/Last-Súper-Mario-Bros-HORIZONTAL-1280x720.jpg',
    type: 'image'
  }, {
    content: 'https://i.blogs.es/733bd1/2560_3000/840_560.jpeg',
    type: 'image'
  }, {
    content: 'https://i.blogs.es/2ed8d3/super-mario-bros-2/840_560.jpeg',
    type: 'image'
  }],
  replyTo: 'msj7g',
  date: 'Mon Jun 07 2021 15:55:10 GMT-0400',
  state: 'sending'
}];